export const TAGS_ICON = {
  author: 'person_outline',
  category: 'ballot',
  'class-level': 'school',
  competence: 'lightbulb_outline',
  instrument: 'architecture',
  subject: 'book',
  topic: 'topic',
  panduan: 'list',
  regulasi: 'gavel',
  inspirasi: 'stars-circle',
  folder_shared: 'folder_shared',
}

export const ERROR_STATE_TRACKER_ACTIVITY_TYPE = {
  NotFoundError: 'ERROR_NO_RESULTS',
  NotFoundWithFiltersError: 'ERROR_NO_RESULTS_FILTER',
  InternalServerError: 'ERROR_SYSTEM_ERROR',
  NetworkError: 'ERROR_NO_INTERNET',
}
